import { gql } from '@apollo/client'

export const ADD_USER_TO_ORGANIZATION = gql`
  mutation addUserToOrganization($email: String!, $organizationId: String!) {
    addUserToOrganization(data: { email: $email, organizationId: $organizationId }) {
      id
    }
  }
`
